"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SpinCardBarebones = _interopRequireDefault(require("./SpinCardBarebones"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const getProductForDomainEntry = (domainEntry = {}, productsList = []) => {
  return productsList.find(product => domainEntry.ProductId === product.ProductId);
};
const SpinsDomainAndPrice = ({
  priceData = {
    ExactMatchDomains: [],
    Products: []
  },
  AddToCartButton,
  PriceBlock
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "spins-result",
    className: "ux-card gd border-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dpp-results"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "spin-results-wrap"
  }, priceData.ExactMatchDomains.map((domain, index) => {
    const domainData = domain;
    const product = getProductForDomainEntry(domainData, priceData.Products);
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_SpinCardBarebones.default, {
      domain,
      domainData,
      product,
      PriceBlock,
      AddToCartButton
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "bd-t-1 bd-product-midrange"
    }));
  }))));
};
SpinsDomainAndPrice.propTypes = {
  PriceBlock: _propTypes.default.func.isRequired,
  AddToCartButton: _propTypes.default.func.isRequired,
  priceData: _propTypes.default.object
};
var _default = exports.default = SpinsDomainAndPrice;